// Atributo personalizado de data é uma data de calendário, sem fuso: grava-se "AAAA-MM-DD".
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const UTC_MIDNIGHT = /^(\d{4}-\d{2}-\d{2})T00:00:00(\.0+)?Z$/;

const pad = number => String(number).padStart(2, '0');

// Devolve "AAAA-MM-DD" ou '' (valor vazio ou que não é data). Valores antigos gravados como ISO:
// a meia-noite UTC era o dia escolhido na tela de Contatos; os demais instantes eram a meia-noite local.
export const toDateOnly = value => {
  const text = value ? String(value) : '';
  if (DATE_ONLY.test(text)) return text;
  const utcMidnight = UTC_MIDNIGHT.exec(text);
  if (utcMidnight) return utcMidnight[1];

  const date = new Date(text);
  if (!text || Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

// Texto exibido ao usuário, no formato local, sem deslocar o dia.
export const formatDateOnly = value => {
  const dateOnly = toDateOnly(value);
  if (!dateOnly) return '';
  const [year, month, day] = dateOnly.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString();
};

export const todayDateOnly = () => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};
